import { useTranslation } from 'react-i18next';
import { LegalShell, LegalLead, LegalH2, LegalP } from './LegalPages';

export function PressPage() {
  const { t } = useTranslation();

  const releases = [
    {
      date: t('press.release_v1_date'),
      title: t('press.release_v1_title'),
      body: t('press.release_v1_body'),
    },
    {
      date: t('press.release_family_date'),
      title: t('press.release_family_title'),
      body: t('press.release_family_body'),
    },
  ];

  return (
    <LegalShell titleKey="press.title">
      <LegalLead>{t('press.lead')}</LegalLead>

      <LegalH2>{t('press.releases_title')}</LegalH2>
      <div className="mt-4 space-y-px bg-ink-200 border border-ink-200">
        {releases.map((r) => (
          <article key={r.title} className="bg-white p-5">
            <p className="text-xs uppercase tracking-wide text-ink-500 font-mono">{r.date}</p>
            <p className="mt-2 text-sm font-semibold text-ink-900">{r.title}</p>
            <p className="mt-2 text-[13px] text-ink-600 leading-relaxed">{r.body}</p>
          </article>
        ))}
      </div>

      <LegalH2>{t('press.bio_title')}</LegalH2>
      <LegalP>{t('press.bio_body')}</LegalP>

      <LegalH2>{t('press.assets_title')}</LegalH2>
      <LegalP>{t('press.assets_body')}</LegalP>
      <p className="mt-3">
        <a href="#" className="text-sm font-semibold text-accent-700 hover:text-accent-600 underline underline-offset-2">
          {t('press.assets_link')} →
        </a>
      </p>

      <LegalH2>{t('press.contact_title')}</LegalH2>
      <LegalP>
        <code className="text-ink-900 font-mono">{t('press.contact_email')}</code>
      </LegalP>
    </LegalShell>
  );
}
